// ** Third Party Imports
import { fetchBaseQuery } from '@reduxjs/toolkit/query'

// ** Lib Imports
import { env } from '../lib'

const baseQuery = fetchBaseQuery({
	baseUrl: env.apiUrl,
	credentials: 'include' // ensures cookies are sent
})

/**
 * fortunai.co is a static marketing website and performs no authentication.
 * The token-refresh flow (which previously issued /auth/refresh and
 * /auth/logout requests on a 401) has been intentionally removed — all
 * authenticated application access happens through app.fortunai.co.
 */
export const baseQueryWithReauth: typeof baseQuery = async (
	args,
	api,
	extraOptions
) => {
	return await baseQuery(args, api, extraOptions)
}
